import { onBeforeUnmount, ref } from "@vue/composition-api";
import { LiveChatInvitation, LiveChatInvitationProcessAction } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import config from "@/config";
import { EVENTS } from "@/const";

export const usePrivateLiveInvitationProducer = (userId: string) => {
  const privateLiveInvitations = ref<LiveChatInvitation[]>([]);

  const getPrivateInvitations = async () => {
    privateLiveInvitations.value = await providers.LivechatsProvider.invitationSearch({
      data: { recipientId: userId },
    });
  };

  const invitationApprove = async (invitation: LiveChatInvitation) => {
    await providers.LivechatsProvider.invitationProcess({
      data: {
        senderId: invitation.senderId,
        recipientId: invitation.recipientId,
        action: LiveChatInvitationProcessAction.ACCEPT,
      },
    });
    privateLiveInvitations.value = [];
  };

  const invitationDecline = async (invitation: LiveChatInvitation) => {
    const response = await providers.LivechatsProvider.invitationProcess({
      data: {
        senderId: invitation.senderId,
        recipientId: invitation.recipientId,
        action: LiveChatInvitationProcessAction.DECLINE,
      },
    });
    if (response) {
      privateLiveInvitations.value = privateLiveInvitations.value.filter(item => item.senderId !== invitation.senderId);
    }
  };

  const onInvitationCreated = (notification?: Notification) => {
    if (!notification) return;
    if (notification.user) {
      const invitation: LiveChatInvitation = {
        senderId: notification.userId,
        sender: notification.user,
        recipientId: notification.recipientId,
      };
      privateLiveInvitations.value = [...privateLiveInvitations.value, invitation];
    }
  };

  const onInvitationDeclined = (notification?: Notification) => {
    if (!notification) return;
    privateLiveInvitations.value = privateLiveInvitations.value.filter(item => item.senderId !== notification.userId);
  };

  if (config.featurePrivateLives) {
    emitter.on<Notification>(EVENTS.LIVECHAT_INVITATION_CREATED, onInvitationCreated);
    emitter.on<Notification>(EVENTS.LIVECHAT_INVITATION_DECLINED, onInvitationDeclined);

    onBeforeUnmount(() => {
      emitter.off<Notification>(EVENTS.LIVECHAT_INVITATION_CREATED, onInvitationCreated);
      emitter.off<Notification>(EVENTS.LIVECHAT_INVITATION_DECLINED, onInvitationDeclined);
    });

    getPrivateInvitations();
  }

  return {
    privateLiveInvitations,
    getPrivateInvitations,
    invitationApprove,
    invitationDecline,
  };
};
